import React from "react";
import { useTheme } from "styled-components";

const OrgChart = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.313 7.875h-6.75V6.188h.562a1.125 1.125 0 0 0 1.125-1.125v-2.25a1.125 1.125 0 0 0-1.125-1.126h-2.25A1.125 1.125 0 0 0 6.75 2.814v2.25a1.125 1.125 0 0 0 1.125 1.125h.563v1.687h-6.75a.563.563 0 1 0 0 1.125h2.25v2.25h-.563a1.125 1.125 0 0 0-1.125 1.125v2.25a1.125 1.125 0 0 0 1.125 1.125h2.25a1.125 1.125 0 0 0 1.125-1.125v-2.25a1.125 1.125 0 0 0-1.125-1.125h-.562V9h7.875v2.25h-.563a1.125 1.125 0 0 0-1.125 1.125v2.25a1.125 1.125 0 0 0 1.125 1.125h2.25a1.125 1.125 0 0 0 1.125-1.125v-2.25a1.125 1.125 0 0 0-1.125-1.125h-.562V9h2.25a.562.562 0 1 0 0-1.125M7.874 2.813h2.25v2.25h-2.25zm-2.25 11.812h-2.25v-2.25h2.25zm9 0h-2.25v-2.25h2.25z"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default OrgChart;
